import {Link} from '@mui/material';
import React, {Fragment, useState} from 'react';

import {AlertInfo, IFrameModal, Snackbar} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {Drawer} from 'presentation/components/Drawer';

import {useMediaQueries} from 'presentation/pages/private/hooks';
import {useHostName} from 'presentation/hooks';
import {useGetFaqUrlQuery} from 'presentation/pages/private/help/queries/useGetFaqUrlQuery';

const {learnMore, agreementText, needHelp, tryAgainLater} = translations['pt-br'].commons;
const {
	specialtyAlert: {description, drawer},
} = translations['pt-br'].privateFlow.ourDoctor;
const {faq} = translations['pt-br'].privateFlow.help;

export function OurDoctorSpecialtyAlert() {
	const {isMobile} = useMediaQueries();
	const [isDrawerOpenState, setIsDrawerOpenState] = useState(false);
	const {isGndiSaoPaulo} = useHostName();
	const [openFaqIframe, setOpenFaqIFrame] = useState(false);
	const [isErrorState, setIsFaqErrorState] = useState(false);
	const {data: faqData, refetch: getFaqData, isLoading: isFaqLoading} = useGetFaqUrlQuery();

	const handleOpenDrawer = () => {
		setIsDrawerOpenState(true);
	};

	const handleCloseDrawer = () => {
		setIsDrawerOpenState(false);
	};

	const handleGetHelp = async () => {
		const {data, isError} = await getFaqData();
		if (isError) {
			setIsFaqErrorState(true);
			return;
		}
		if (data?.url) {
			if (isGndiSaoPaulo) {
				setOpenFaqIFrame(true);
			} else {
				window.open(data.url, '_blank');
			}
		}
	};

	return (
		<Fragment>
			<AlertInfo.Root sx={{borderRadius: 0}}>
				{description}
				<Link
					variant="body2"
					fontWeight={600}
					color="primary"
					sx={{cursor: 'pointer'}}
					onClick={handleOpenDrawer}>
					{learnMore}
				</Link>
			</AlertInfo.Root>
			<Drawer.Root
				open={isDrawerOpenState}
				onClose={handleCloseDrawer}
				onOpen={handleOpenDrawer}
				width="396px"
				customMaxHeight="100%"
				sx={{zIndex: 9000}}>
				<Drawer.Header onClose={handleCloseDrawer} title={drawer.title} />
				<Drawer.Content mt={isMobile ? 0 : 1}>{drawer.description}</Drawer.Content>
				<Drawer.Footer
					secondButtonTitle={agreementText}
					secondButtonOnClick={handleCloseDrawer}
					firstButtonTitle={needHelp}
					firstButtonOnClick={handleGetHelp}
					firstButtonDisabled={isFaqLoading}
					firstButtonIsLoading={isFaqLoading}
					canStacks
				/>
			</Drawer.Root>

			<Snackbar
				message={tryAgainLater}
				open={isErrorState}
				onClose={() => setIsFaqErrorState(false)}
				sx={{
					mb: isMobile ? '112px' : '50px',
					zIndex: 9999,
					mr: isMobile ? undefined : -1.5,
				}}
			/>

			{isGndiSaoPaulo ? (
				<IFrameModal
					openIframe={openFaqIframe}
					setOpenIframe={setOpenFaqIFrame}
					title={faq.cardTitle}
					url={faqData?.url || ''}
				/>
			) : null}
		</Fragment>
	);
}
